import { AxiosInstance } from 'axios';
import { ApplogUserlog } from 'services';

export interface UserLogService {
  getAll: ReturnType<typeof ApplogUserlog.getAll>;
  getAllBusinessActions: ReturnType<typeof ApplogUserlog.getAllBusinessActions>;
}

export const initUserLogService = (axios: AxiosInstance): UserLogService => ({
  getAll: ApplogUserlog.getAll(axios),
  getAllBusinessActions: ApplogUserlog.getAllBusinessActions(axios),
});
